// src/pages/CategoryPage.jsx
import { Link, useParams } from "react-router-dom";
import posts from "../data/posts.json";
import "../styles/category-page.css";

const categoryDescriptions = {
  esotericism:
    "Writings on symbolism, occult systems, metaphysics, ritual, secrecy, mysticism, hidden structures of meaning.",
  cybernetics:
    "Writings on systems, control, feedback, machines, interfaces, networks, technological culture.",
  politics:
    "Writings on economics, ideology, power, social order, labor, class, historical change.",
  medieval:
    "Writings on medieval history, religious institutions, symbolic order, feudal structures, premodern life.",
  literature:
    "Writings on fiction, criticism, poetics, style, narrative structure, literary theory.",
  music:
    "Writings on sound, genre, criticism, musical history, atmosphere, sonic identity.",
  projects:
    "Build logs, experiments, creative systems, technical prototypes, strange ongoing constructions."
};

const formatTitle = (categoryId) => {
  const titles = {
    esotericism: "Esotericism",
    cybernetics: "Cybernetics",
    politics: "Politics",
    medieval: "Medieval",
    literature: "Literature",
    music: "Music",
    projects: "Projects"
  };

  return titles[categoryId] || "Category";
};

const CategoryPage = () => {
  const { categoryId } = useParams();

  const categoryPosts = posts.filter((post) => post.category === categoryId);

  return (
    <div className="category-page">
      <div className="category-page__inner">
        <header className="category-page__header">
          <span className="category-page__eyebrow">Category Archive</span>
          <h1>{formatTitle(categoryId)}</h1>
          <p>{categoryDescriptions[categoryId]}</p>
        </header>

        <section className="category-page__grid">
          {categoryPosts.map((post) => (
            <Link
              key={post.slug}
              to={`/post/${post.slug}`}
              className="category-page__card"
            >
              <h2>{post.title}</h2>
              <p>{post.excerpt}</p>
            </Link>
          ))}
        </section>
      </div>
    </div>
  );
};

export default CategoryPage;